import { useSelector } from 'react-redux';
import moment from 'moment';

import { toggleOnlyOwn } from '~actions/transferActions';

import TaskListFilters from './TaskListFilters';
import Modal from './Modal';
import TaskList from './TaskList';

const TaskListView = () => {
  const isFetchingTasks = useSelector(
    state => state.transferReducers.isFetchingTasks
  );
  const lastUpdated = useSelector(state => state.transferReducers.lastUpdated);
  const onlyOwn = useSelector(state => state.transferReducers.onlyOwn);
  const startDate = useSelector(state =>
    moment(state.transferReducers.startDate).format('DD.MM.YYYY')
  );
  const endDate = useSelector(state =>
    moment(state.transferReducers.endDate).format('DD.MM.YYYY')
  );
  const isSearched = useSelector(state => state.transferReducers.isSearched);
  const pageOffset = useSelector(state => state.transferReducers.pageOffset);

  return (
    <div>
      <TaskListFilters
        lastUpdated={lastUpdated}
        onlyOwn={onlyOwn}
        toggleOnlyOwn={toggleOnlyOwn}
        startDate={startDate}
        endDate={endDate}
        isSearched={isSearched}
        pageOffset={pageOffset}
      />
      <TaskList isFetchingTasks={isFetchingTasks} />
      <Modal />
    </div>
  );
};

export default TaskListView;
